export class BankIdAuthRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validate(request) {
        if (!request) {
            throw new Error("Request can not be falsy");
        }
        if (!request.method) {
            throw new Error("Missing auth method");
        }
    }
    withMethod(method) {
        this.properties.method = method;
        return this;
    }
    build() {
        return this.properties;
    }
}
